import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  generales: {
    padding: theme.spacing(2),
  },
  btnClonarPrincipal: {
    backgroundColor: '#0284c7',
    color: '#ffffff',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    '&:hover': {
      backgroundColor: '#0369a1',
    },
  },
  modalCampoContainer: {
    marginBottom: theme.spacing(2),
  },
  modalCampoLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: '#374151',
    marginBottom: 6,
  },
  modalSelect: {
    '& .MuiSelect-root': {
      padding: '10px 14px',
      fontSize: 14,
    },
  },
  modalAdvertenciaContenido: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  modalTextoPrincipal: {
    fontSize: 14,
    color: '#374151',
    marginBottom: 10,
    lineHeight: 1.5,
  },
  modalNombrePlantilla: {
    fontSize: 15,
    fontWeight: 700,
    color: '#0f172a',
    backgroundColor: '#f1f5f9',
    padding: '8px 12px',
    borderRadius: 6,
    marginBottom: 14,
    border: '1px solid #e2e8f0',
  },
  modalAlertaBox: {
    fontSize: 13,
    color: '#991b1b',
    backgroundColor: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: 6,
    padding: '10px 14px',
    lineHeight: 1.4,
    marginBottom: 10,
  },
  modalAlertaBoxWarning: {
    fontSize: 13,
    color: '#92400e',
    backgroundColor: '#fffbeb',
    border: '1px solid #fef3c7',
    borderRadius: 6,
    padding: '10px 14px',
    lineHeight: 1.4,
    marginBottom: 10,
  },
  modalBtnConfirmar: {
    backgroundColor: '#dc2626',
    color: '#ffffff',
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#b91c1c',
    },
  },
  modalBtnContinuar: {
    backgroundColor: '#0284c7',
    color: '#ffffff',
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#0369a1',
    },
  },
  modalBtnCancelar: {
    textTransform: 'none',
    marginRight: 8,
  },
  editorSection: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  editorHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    flexWrap: 'wrap',
    gap: 8,
  },
  editorLabel: {
    fontSize: 14,
    fontWeight: 600,
    color: '#374151',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    margin: 0,
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: 12,
    marginTop: 4,
  },
  ayudaTexto: {
    fontSize: 12,
    color: '#6b7280',
    marginBottom: 8,
  },
}));
